/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DbrBalloonEventIdResponseDto } from '../../models/dbr-balloon-event-id-response-dto';

export interface BalloonsControllerFindEventIdByCode$Params {
  code: string;
}

export function balloonsControllerFindEventIdByCode(http: HttpClient, rootUrl: string, params: BalloonsControllerFindEventIdByCode$Params, context?: HttpContext): Observable<StrictHttpResponse<DbrBalloonEventIdResponseDto>> {
  const rb = new RequestBuilder(rootUrl, balloonsControllerFindEventIdByCode.PATH, 'get');
  if (params) {
    rb.path('code', params.code, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DbrBalloonEventIdResponseDto>;
    })
  );
}

balloonsControllerFindEventIdByCode.PATH = '/balloons/eventid/{code}';
